import React from 'react';
import './Footer.css'; // Assuming we will create this CSS file

const Footer: React.FC = () => {
  return (
    <footer className="main-footer">
      <div className="container">
        <p>&copy; {new Date().getFullYear()} Sabots du Petit Morin. Tous droits réservés.</p>
        <p>Contact : <a href="mailto:contact@sabotsdupetitmorin.fr">contact@sabotsdupetitmorin.fr</a> | 
          <a href="/cgv" className="c-gv">Conditions Générales de Vente (CGV)</a></p>
      </div>
    </footer>
  );
};

export default Footer;